import * as React from "react";
import "./FacesheetOtherFinancial.scss";
import { isNotNullOrWhitespace } from "../../services/stringService";

export const FacesheetOtherFinancial = ({ assets, expenses, debts }) => {
    return (
        <div className="facesheet-other-financial">
            {expenses?.length > 0 && (
                <div>
                    <h4 className="facesheet-other-financial__name">Expenses</h4>
                    <div className="facesheet-other-financial__container">
                        {expenses.map((expense, i) => {
                            return (
                                <div className="facesheet-other-financial__card" key={i}>
                                    <h4 className="facesheet-other-financial__line-item-name">
                                        {expense.type} {isNotNullOrWhitespace(expense.name) && `(${expense.name})`}
                                    </h4>
                                    <p>
                                        <span className="h5">Amount: </span>${expense.amount}
                                    </p>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
            {debts?.length > 0 && (
                <div>
                    <h4 className="facesheet-other-financial__name">Debts</h4>
                    <div className="facesheet-other-financial__container">
                        {debts.map((debt, i) => {
                            return (
                                <div className="facesheet-other-financial__card" key={i}>
                                    <h4 className="facesheet-other-financial__line-item-name">
                                        {debt.type} ({debt.name})
                                    </h4>
                                    <p>
                                        <span className="h5">Amount: </span>${debt.amount}
                                    </p>
                                    <p>
                                        <span className="h5">Outstanding Balance: </span>${debt.outstandingBalance}
                                    </p>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
            {assets?.length > 0 && (
                <div>
                    <h4 className="facesheet-other-financial__name">Assets</h4>
                    <div className="facesheet-other-financial__container">
                        {assets.map((asset, i) => {
                            return (
                                <div className="facesheet-other-financial__card" key={i}>
                                    <h4 className="facesheet-other-financial__line-item-name">{asset.type}</h4>
                                    <p>
                                        <span className="h5">Value: </span>${asset.value}
                                    </p>
                                    {asset.jointlyOwned && (
                                        <span className="p-small facesheet-other-financial__line-item-jointly">
                                            *Jointly Owned
                                        </span>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};
